module.exports = __webpack_public_path__ + "static/media/the-university-of-sydney.389ccd9b.png";